<template>
    <nav class="side-nav">
        <NavLink
            :href="route('dashboard')"
            class="flex items-center pl-5 pt-4"
        >
            <span class="hidden xl:block text-white text-lg ml-3">Tax Clinic</span>
        </NavLink>
        <div class="side-nav__devider my-6"></div>
        <ul>
            <SidebarLink
                v-for="link in links"
                v-show="checkPermission(link, $page)"
                :href="route(link.href, link.options || {})"
                :component="link.component"
                :title="link.title"
                :icon="link.icon"
            />
        </ul>
    </nav>

</template>

<script setup>
import links from '../json/sidebar-links.json';
import SidebarLink from "./SidebarLink";

const checkPermission = (link, page) => {
    if (!link.auth) {
        return true;
    }
    return page.props.auth.user.isAdmin;
};
</script>
